import { useState } from "react";
import { useMsal } from '@azure/msal-react';

import { Typography, Space, Row } from "antd";
import { WarningOutlined } from "@ant-design/icons";

import LoginService from './../../services/LoginService.js';
import { useAuthCuadroMando } from "../../systems/cuadro_mando/context/AuthCuadroMandoContext.js";
import { LoginMSSO, LogoutMSSO } from "./../../services/LoginMSSOService.js";


import CustomModal from "./../../component/ModalCustom.js";

import WindowsLogo from "./../../assets/images/iconos/WindowsLogo.ico";
import llave from "./../../assets/images/iconos/llave.ico";

import { ButtonCustom, ButtonCustomLink } from "./../../component/Button";
import { COLOR_WARNING } from "../../shared/constants";


export default function LoginForm() {
  const { instance, accounts } = useMsal();
  const [dataModal, setDataModal] = useState({ icon: <WarningOutlined />, title: "", message: "", modalVisible: false, color: undefined });
  const { getUserCMIProfile } = useAuthCuadroMando();

  const { Title } = Typography;

  const logIn = async () => {

    const loginMSSOResponse = await LoginMSSO(instance);
    if (!loginMSSOResponse.success) {
      setDataModal({ ...dataModal, message: loginMSSOResponse?.message, modalVisible: true, color: COLOR_WARNING });
      return;
    };

    const response = await LoginService.login(loginMSSOResponse);
    if (response.success) {
      getUserCMIProfile();
    } else {
      setDataModal({ ...dataModal, message: response?.message, modalVisible: true, color: COLOR_WARNING });
      return;
    }
  }
  return (
    <>
      <Row className="paddingPersonalizado">
        <Row>
          <Title className="pompisLight subTitleColor " level={2}>Bienvenidos a👋 <div className="pompisSemiBold titleColor">Servicios Administrativos</div></Title>
        </Row>
        <Row>
          <div style={{ marginBottom: "40px" }} />
          <Title className="pompisLight textColor" level={4} >
            Inicia sesión con tu correo institucional para acceder a todas las herramientas y funciones.
          </Title>
          <div style={{ marginBottom: "50px" }} />
        </Row>

        <Space className="spaceForm" direction="vertical" >
          <ButtonCustom onClick={logIn} icon={<img src={WindowsLogo} alt="Logotipo Windows" />} className="subTitleColor custom-submit-button" >Iniciar sesión con Correo Institucional</ButtonCustom>
          <ButtonCustomLink link="/solicitud-de-acceso" icon={<img src={llave} alt="Logotipo llave" />}>
            Solicitar Acesso 
          </ButtonCustomLink>
        </Space>

      </Row>
      <CustomModal
        dataModal={dataModal}
        setDataModal={async (value) => {
          if (!value.modalVisible) {
            await LogoutMSSO(instance, accounts);
          }
          setDataModal({ ...dataModal, modalVisible: value.modalVisible });
        }}
      />
    </>
  );
}

